"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayTypeListRequest = void 0;
var PayTypeListRequest = /** @class */ (function () {
    function PayTypeListRequest() {
    }
    return PayTypeListRequest;
}());
exports.PayTypeListRequest = PayTypeListRequest;
;
//# sourceMappingURL=payTypeList.request.js.map